import React, { useState, useEffect, useCallback } from "react";
import { ImportMinor } from "@shopify/polaris-icons";
import { ButtonGroup, Button, Modal, OptionList } from "@shopify/polaris";
import { Row, Col } from "reactstrap";

import callApi from "../../utils/apiCaller";

const ExportOrders = (props) => {
	const [active, setActive] = useState(false);
	const [selectedFields, setSelectedFields] = useState([
		"shop",
		"order_id",
		"name",
		"payment_gateway_names",
		"tracking_number",
		"tracking_company",
		"transaction_id",
		"add_tracking_status",
		"pay_pal_account_id",
		"processed_at",
	]);
	const listFields = [
		{ value: "shop", label: "Shop" },
		{ value: "order_id", label: "Order Id" },
		{ value: "name", label: "Order Name" },
		{ value: "payment_gateway_names", label: "Payment gateway names" },
		{ value: "tracking_number", label: "Tracking number" },
		{ value: "tracking_company", label: "Tracking company" },
		{ value: "transaction_id", label: "Transaction id" },
		{ value: "add_tracking_status", label: "Sync Status" },
		{ value: "pay_pal_account_id", label: "PayPal Account" },
		{ value: "processed_at", label: "Processed At" },
	];

	const exportOrderList = useCallback(() => {
		let params = {
			action: "exportOrderList",
			fields: JSON.stringify(selectedFields),
			search: props.search,
			date_range: props.dateRange[0],
			status: props.status[0],
			store: JSON.stringify(props.store),
			payment: props.payment[0],
		};

		callApi("get", params).then((res) => {
			if (res.data.state === 1) {
				window.open(res.data.exportLink, "_blank");
				setActive(false);
			}
		});
	});
	return (
		<div>
			<Row>
				<Col
					style={{ display: "flex", alignItems: "flex-end" }}
					className="ml-4"
				>
					<div>
						<a
							href="https://docs.synctrack.io/feature-guides/how-to-check-sync-status-add-tracking-auto-app#payment-filter-the-payment-you-would-like-to-show-the-order "
							target="_blank"
						>
							View Order Document
						</a>
					</div>
				</Col>
				<Col
					style={{ display: "flex", justifyContent: "flex-end" }}
					className="mr-4"
				>
					<ButtonGroup segmented>
						<Button
							icon={ImportMinor}
							onClick={() => setActive(true)}
						>
							<span>Export</span>
						</Button>
					</ButtonGroup>
				</Col>
			</Row>

			<div className="float-right mr-4">
				<Modal
					open={active}
					onClose={() => setActive(false)}
					title="Export Options"
					primaryAction={{
						content: "Export",
						onAction: exportOrderList,
					}}
					secondaryActions={[
						{
							content: "Cancel",
							onAction: () => setActive(false),
						},
					]}
				>
					<Modal.Section>
						<OptionList
							title="Field to export:"
							onChange={setSelectedFields}
							options={listFields}
							selected={selectedFields}
							allowMultiple
						/>
					</Modal.Section>
				</Modal>
			</div>
		</div>
	);
};

export default ExportOrders;
